import { otherApiClient } from ".";
export const DEFAULT_QUERY_SIZE = 1;
export const getCategoryMenu = async ()=>{
    const { data  } = await otherApiClient.market("/menu-categories");
    return data;
};
export const SortType = {
    POPULAR: "인기순",
    NEW: "최신순",
    LOWPRICE: "낮은가격순",
    NAME: "이름순"
};
export const DetailFilterKeys = {
    UNITS: "단원",
    DATATYPES: "자료유형",
    AUTHORS: "제작자",
    RELATEDBOOKS: "교재",
    TICKETS: "이용권",
    SOLVOOKPASS: "쏠북패스"
};
export const CategoryQueryKey = {
    CATEGORY: "id",
    SORT: "sort"
};
export const getCategoryList = async (param)=>{
    let { id , ...rest } = param;
    const { data  } = await otherApiClient.market("/menu-categories/".concat(id), {
        params: rest
    });
    return data;
};
